import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PageTransition from "./PageTransition";

import Index from "@/pages/Index";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Weather from "@/pages/Weather";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Book from "@/pages/Book";
import ServiceAreas from "@/pages/ServiceAreas";
import AirportTransferSAT from "@/pages/AirportTransferSAT";
import AirportTransportation from "@/pages/AirportTransportation";
import CorporateTravel from "@/pages/CorporateTravel";
import SpecialEvents from "@/pages/SpecialEvents";
import HourlyService from "@/pages/HourlyService";
import CarServiceNewBraunfels from "@/pages/CarServiceNewBraunfels";
import CarServiceBoerne from "@/pages/CarServiceBoerne";
import CarServiceAustin from "@/pages/CarServiceAustin";
import CarServiceCanyonLake from "@/pages/CarServiceCanyonLake";
import CarServiceFairOaksRanch from "@/pages/CarServiceFairOaksRanch";
import CarServiceLakehills from "@/pages/CarServiceLakehills";
import CarServiceSeguin from "@/pages/CarServiceSeguin";
import CarServiceWimberley from "@/pages/CarServiceWimberley";
import CarServiceSanAntonio from "@/pages/CarServiceSanAntonio";
import ChauffeurServiceSanAntonio from "@/pages/ChauffeurServiceSanAntonio";
import SanAntonioToAustin from "@/pages/SanAntonioToAustin";
import SanAntonioToHouston from "@/pages/SanAntonioToHouston";
import WineTours from "@/pages/WineTours";
import WeddingTransportation from "@/pages/WeddingTransportation";
import MilitaryTransportation from "@/pages/MilitaryTransportation";
import MilitaryGraduationTransportation from "@/pages/MilitaryGraduationTransportation";
import BMTGraduation from "@/pages/BMTGraduation";
import BAMCTransportation from "@/pages/BAMCTransportation";
import RandolphAFBTransportation from "@/pages/RandolphAFBTransportation";
import MilitaryFamilies from "@/pages/MilitaryFamilies";
import JBSAMilitaryTransportation from "@/pages/JBSAMilitaryTransportation";
import CampBullisTransportation from "@/pages/CampBullisTransportation";
import FuneralTransportation from "@/pages/FuneralTransportation";
import ServiceArea from "@/pages/ServiceArea";
import Fleet from "@/pages/Fleet";
import NotFound from "@/pages/NotFound";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPosts from "@/pages/admin/AdminPosts";
import AdminPostEditor from "@/pages/admin/AdminPostEditor";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminFollowUps from "@/pages/admin/AdminFollowUps";
import AdminEmailTemplates from "@/pages/admin/AdminEmailTemplates";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminAIKnowledge from "@/pages/admin/AdminAIKnowledge";
import AdminFeedback from "@/pages/admin/AdminFeedback";
import AdminSEO from "@/pages/admin/AdminSEO";
import OAuthConsent from "@/pages/OAuthConsent";
import RequestQuote from "@/pages/RequestQuote";
import QuickQuote from "@/pages/QuickQuote";
import PasswordReset from "@/pages/PasswordReset";
import LandingPage from "@/pages/LandingPage";
import FortSamHoustonFuneralGuide from "@/pages/blog/FortSamHoustonFuneralGuide";
import LuxurySuvVsLimoSanAntonio from "@/pages/blog/LuxurySuvVsLimoSanAntonio";

const AnimatedRoutes = () => {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Index /></PageTransition>} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/about" element={<PageTransition><About /></PageTransition>} />
        <Route path="/services" element={<PageTransition><Services /></PageTransition>} />
        <Route path="/fleet" element={<PageTransition><Fleet /></PageTransition>} />
        <Route path="/weather" element={<PageTransition><Weather /></PageTransition>} />
        <Route path="/testimonials" element={<PageTransition><Testimonials /></PageTransition>} />
        <Route path="/contact" element={<PageTransition><Contact /></PageTransition>} />
        <Route path="/faq" element={<PageTransition><FAQ /></PageTransition>} />
        <Route path="/book" element={<PageTransition><Book /></PageTransition>} />
        <Route path="/request-quote" element={<PageTransition><RequestQuote /></PageTransition>} />
        <Route path="/quick-quote" element={<PageTransition><QuickQuote /></PageTransition>} />
        <Route path="/password-reset" element={<PageTransition><PasswordReset /></PageTransition>} />
        <Route path="/service-areas" element={<PageTransition><ServiceAreas /></PageTransition>} />
        <Route path="/service-area" element={<PageTransition><ServiceArea /></PageTransition>} />
        <Route path="/airport-transfer-san-antonio-sat" element={<PageTransition><AirportTransferSAT /></PageTransition>} />
        
        {/* Service Routes with /services/ prefix */}
        <Route path="/services/airport-transportation" element={<PageTransition><AirportTransportation /></PageTransition>} />
        <Route path="/sat-airport-transfers" element={<PageTransition><AirportTransferSAT /></PageTransition>} />
        <Route path="/services/corporate-travel" element={<PageTransition><CorporateTravel /></PageTransition>} />
        <Route path="/services/wedding-transportation" element={<PageTransition><WeddingTransportation /></PageTransition>} />
        <Route path="/services/special-events" element={<PageTransition><SpecialEvents /></PageTransition>} />
        <Route path="/services/hourly-service" element={<PageTransition><HourlyService /></PageTransition>} />
        <Route path="/services/wine-tours" element={<PageTransition><WineTours /></PageTransition>} />
        <Route path="/services/military-transportation" element={<PageTransition><MilitaryTransportation /></PageTransition>} />
        <Route path="/bmt-graduation" element={<PageTransition><BMTGraduation /></PageTransition>} />
        <Route path="/bamc-transportation" element={<PageTransition><BAMCTransportation /></PageTransition>} />
        <Route path="/randolph-afb-transportation" element={<PageTransition><RandolphAFBTransportation /></PageTransition>} />
        <Route path="/military-families" element={<PageTransition><MilitaryFamilies /></PageTransition>} />
        <Route path="/jbsa-military-transportation" element={<PageTransition><JBSAMilitaryTransportation /></PageTransition>} />
        <Route path="/camp-bullis-transportation" element={<PageTransition><CampBullisTransportation /></PageTransition>} />
        <Route path="/services/funeral-transportation" element={<PageTransition><FuneralTransportation /></PageTransition>} />
        
        {/* Legacy routes */}
        <Route path="/airport-transportation" element={<PageTransition><AirportTransportation /></PageTransition>} />
        <Route path="/corporate-travel" element={<PageTransition><CorporateTravel /></PageTransition>} />
        <Route path="/corporate-transportation" element={<PageTransition><CorporateTravel /></PageTransition>} />
        <Route path="/special-events" element={<PageTransition><SpecialEvents /></PageTransition>} />
        <Route path="/hourly-service" element={<PageTransition><HourlyService /></PageTransition>} />
        <Route path="/wine-tours" element={<PageTransition><WineTours /></PageTransition>} />
        <Route path="/wedding-transportation" element={<PageTransition><WeddingTransportation /></PageTransition>} />
        <Route path="/military-graduation-transportation" element={<PageTransition><MilitaryGraduationTransportation /></PageTransition>} />
        
        {/* City Service Routes */}
        <Route path="/san-antonio-car-service" element={<PageTransition><CarServiceSanAntonio /></PageTransition>} />
        <Route path="/chauffeur-service-san-antonio" element={<PageTransition><ChauffeurServiceSanAntonio /></PageTransition>} />
        <Route path="/new-braunfels-car-service" element={<PageTransition><CarServiceNewBraunfels /></PageTransition>} />
        <Route path="/boerne-car-service" element={<PageTransition><CarServiceBoerne /></PageTransition>} />
        <Route path="/austin-car-service" element={<PageTransition><CarServiceAustin /></PageTransition>} />
        <Route path="/canyon-lake-car-service" element={<PageTransition><CarServiceCanyonLake /></PageTransition>} />
        <Route path="/fair-oaks-ranch-car-service" element={<PageTransition><CarServiceFairOaksRanch /></PageTransition>} />
        <Route path="/lakehills-car-service" element={<PageTransition><CarServiceLakehills /></PageTransition>} />
        <Route path="/seguin-car-service" element={<PageTransition><CarServiceSeguin /></PageTransition>} />
        <Route path="/wimberley-car-service" element={<PageTransition><CarServiceWimberley /></PageTransition>} />
        
        {/* City-to-City Routes */}
        <Route path="/san-antonio-to-austin" element={<PageTransition><SanAntonioToAustin /></PageTransition>} />
        <Route path="/san-antonio-to-houston" element={<PageTransition><SanAntonioToHouston /></PageTransition>} />
        {/* Legacy City Service URLs */}
        <Route path="/car-service-san-antonio" element={<PageTransition><CarServiceSanAntonio /></PageTransition>} />
        <Route path="/car-service-new-braunfels" element={<PageTransition><CarServiceNewBraunfels /></PageTransition>} />
        <Route path="/car-service-boerne" element={<PageTransition><CarServiceBoerne /></PageTransition>} />
        <Route path="/car-service-austin" element={<PageTransition><CarServiceAustin /></PageTransition>} />
        <Route path="/car-service-canyon-lake" element={<PageTransition><CarServiceCanyonLake /></PageTransition>} />
        <Route path="/car-service-fair-oaks-ranch" element={<PageTransition><CarServiceFairOaksRanch /></PageTransition>} />
        <Route path="/car-service-lakehills" element={<PageTransition><CarServiceLakehills /></PageTransition>} />
        <Route path="/car-service-seguin" element={<PageTransition><CarServiceSeguin /></PageTransition>} />
        <Route path="/car-service-wimberley" element={<PageTransition><CarServiceWimberley /></PageTransition>} />
        
        {/* Blog Routes */}
        <Route path="/blog" element={<PageTransition><Blog /></PageTransition>} />
        <Route path="/blog/fort-sam-houston-funeral-guest-guidelines" element={<PageTransition><FortSamHoustonFuneralGuide /></PageTransition>} />
        <Route path="/blog/luxury-suv-vs-limo-san-antonio" element={<PageTransition><LuxurySuvVsLimoSanAntonio /></PageTransition>} />
        {/* Redirects: merged BMT graduation posts → definitive 2026 guide */}
        <Route path="/blog/lackland-afb-bmt-graduation-transportation-guide" element={<Navigate to="/blog/bmt-graduation-transportation-at-lackland-afb-the-complete-family-guide-2026" replace />} />
        <Route path="/blog/bmt-graduation-transportation-guide-lackland-afb" element={<Navigate to="/blog/bmt-graduation-transportation-at-lackland-afb-the-complete-family-guide-2026" replace />} />
        {/* Redirects: merged JBSA base access posts → definitive JBSA access guide */}
        <Route path="/blog/jbsa-military-base-access-transportation-guide" element={<Navigate to="/blog/what-is-jbsa-access-guide" replace />} />
        <Route path="/blog/jbsa-base-access-military-families-transportation-guide" element={<Navigate to="/blog/what-is-jbsa-access-guide" replace />} />
        {/* Redirect: merged Fort Sam Houston / BAMC posts → definitive medical appointment guide */}
        <Route path="/blog/fort-sam-houston-bamc-transportation" element={<Navigate to="/blog/fort-sam-houston-bamc-medical-appointment-transportation" replace />} />
        {/* Redirect: merged corporate car service post → definitive executive reliability guide */}
        <Route path="/blog/corporate-black-car-service-san-antonio-why-executives-choose-rick-s" element={<Navigate to="/blog/executives-guide-corporate-car-service-san-antonio" replace />} />
        <Route path="/blog/:slug" element={<PageTransition><BlogPost /></PageTransition>} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<PageTransition><AdminLogin /></PageTransition>} />
        <Route path="/admin/dashboard" element={<PageTransition><AdminDashboard /></PageTransition>} />
        <Route path="/admin/posts" element={<PageTransition><AdminPosts /></PageTransition>} />
        <Route path="/admin/posts/new" element={<PageTransition><AdminPostEditor /></PageTransition>} />
        <Route path="/admin/posts/edit/:id" element={<PageTransition><AdminPostEditor /></PageTransition>} />
        <Route path="/admin/inquiries" element={<PageTransition><AdminInquiries /></PageTransition>} />
        <Route path="/admin/follow-ups" element={<PageTransition><AdminFollowUps /></PageTransition>} />
        <Route path="/admin/email-templates" element={<PageTransition><AdminEmailTemplates /></PageTransition>} />
        <Route path="/admin/media" element={<PageTransition><AdminMedia /></PageTransition>} />
        <Route path="/admin/ai-knowledge" element={<PageTransition><AdminAIKnowledge /></PageTransition>} />
        <Route path="/admin/feedback" element={<PageTransition><AdminFeedback /></PageTransition>} />
        <Route path="/admin/seo" element={<PageTransition><AdminSEO /></PageTransition>} />

        {/* OAuth consent for MCP / external clients */}
        <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />

        {/* Catch-all */}
        <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
